import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import AppListField from '../../../../../reusableFields/AppListField'
import Field from '../../../../../../../../../components/Form/Field'
import RadioBlock from '../../../../../../../../../components/Form/RadioBlock'

import useGetAppsData from '../../../../../reusableFields/AppListField/useGetAppsData'

import { selectedFacebookAdAccountSelector } from '../../../../../../../../../modules/selectors/adAccounts'

import { TARGET_COST_CAP } from '../../../../../../../../Multiplatform/LineItemForms/fields'
import { LINE_ITEM_OBJECTIVE, mobilePlatforms, USER_OS } from '../../../../fields'
import { APP_INSTALLS, LINK_CLICKS } from '../../../../../../../../../constants/campaigns'

import useDrawerFormStyles from '../../../../../../../../../styles/common/drawerForms'

const AppPromotionObjectivePromotedObjectFields = ({ formik, showTargetCostCapField }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()

  const { setFieldValue, values } = formik

  const { currency_symbol: currencySymbol } = useSelector(selectedFacebookAdAccountSelector)

  useGetAppsData()

  return (
    <>
      <section className={drawerFormClasses.section}>
        <h2 className={drawerFormClasses.sectionTitle}>Promote type</h2>
        {/*if installs radio button is selected, user must select an app - the validation is added*/}
        <RadioBlock
          setFieldValue={setFieldValue}
          id={APP_INSTALLS}
          name={LINE_ITEM_OBJECTIVE}
          label={t('Promote App Installs')}
          value={APP_INSTALLS}
          selectedValue={values[LINE_ITEM_OBJECTIVE]}
        />
        <RadioBlock
          setFieldValue={setFieldValue}
          id={LINK_CLICKS}
          name={LINE_ITEM_OBJECTIVE}
          label={t('Drive clicks to an app store')}
          value={LINK_CLICKS}
          selectedValue={values[LINE_ITEM_OBJECTIVE]}
        />
      </section>
      <section className={drawerFormClasses.section}>
        <h2 className={drawerFormClasses.sectionTitle}>App Details</h2>
        <AppListField formik={formik} preselectFirstOptionValue={true} />
        <Field
          name={USER_OS}
          formik={formik}
          placeholder="Platform"
          options={mobilePlatforms}
          preselectFirstOptionValue
        />
        {showTargetCostCapField && (
          <Field
            type="number"
            formik={formik}
            name={TARGET_COST_CAP}
            placeholder={t('Average Cost Goal')}
            symbol={currencySymbol}
            autoComplete="off"
          />
        )}
      </section>
    </>
  )
}

AppPromotionObjectivePromotedObjectFields.propTypes = {
  formik: PropTypes.object.isRequired,
  showTargetCostCapField: PropTypes.bool
}

export default AppPromotionObjectivePromotedObjectFields
